module.exports = __webpack_public_path__ + "static/img/Sarah-designer 2.8bcd154.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photoPeople/Sarah-designer 2.png
// module id = HHea
// module chunks = 1